module.exports = __webpack_public_path__ + "static/media/ottawa-34.f938ad0a.jpg";